<div class="kt-portlet kt-portlet--responsive-mobile">
  <div class="kt-portlet__head">
    <div class="kt-portlet__head-label">
      <h2 class="kt-portlet__head-title text-capitalize">Supplier SKUs</h2>
    </div>
  </div>

  <div class="kt-portlet__body supplier-skus--content">
    <div
      class="overlay"
      lumAppLoader
      [loading]="loading"
      [classes]="'loading blur'"
    ></div>

    <!-- Search -->
    <div class="flex justify-content-between">
      <div class="flex gap-2">
        <mat-select
          placeholder="Filter by Supplier"
          class="lum-select"
          [value]="defaultSupplierFilter"
          (selectionChange)="onSelectSupplierFilter($event.value)"
        >
          <mat-option [value]="null">All</mat-option>
          <mat-option
            *ngFor="let supplier of suppliers; trackBy: trackById"
            [value]="supplier.id"
            >{{ supplier.factory_name }}</mat-option
          >
        </mat-select>
      </div>
    </div>
    <ng-container *ngIf="pagination.total > 0; else empty">
      <lum-rfq-supplier-skus-table
        [form]="form"
        [suppliers]="suppliers"
      ></lum-rfq-supplier-skus-table>
      <mat-paginator
        [length]="pagination?.total || 0"
        [pageSize]="pagination?.per_page || paginationConfig.perPage"
        [pageSizeOptions]="paginationConfig.pageSizeOptions"
        [pageIndex]="(pagination?.current_page || 1) - 1"
        (page)="onPaginationEvent($event)"
        aria-label="Select page"
      >
      </mat-paginator>
    </ng-container>

    <ng-template #empty>
      <lum-ui-empty-page title="No records available."></lum-ui-empty-page>
    </ng-template>
  </div>
</div>
